import { render, staticRenderFns } from "./KoreaHeaders.vue?vue&type=template&id=c17a7954&lang=html"
import script from "./KoreaHeaders.vue?vue&type=script&lang=js"
export * from "./KoreaHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports